import React__default from 'react';
import { Article } from '../../components/article/article.esm.js';
import { ArticleBody } from '../../components/article/components/article-body.esm.js';
import { templateTypes } from '../../components/article/types.esm.js';
import { ArticleRelationsList } from '../../components/article-relations-list/article-relations-list.esm.js';
import { MiniArticleList } from '../../components/mini-article-list/mini-article-list.esm.js';
import { YouMayAlsoLike } from '../../components/you-may-also-like/you-may-also-like.esm.js';

var ArticlePage = function ArticlePage(props) {
  var article = props.article,
    miniArticleList = props.miniArticleList,
    articleRelationsList = props.articleRelationsList,
    responsiveAds = props.responsiveAds,
    youMayAlsoLike = props.youMayAlsoLike;
  var isEnterprise = props.article.data.templateType === templateTypes.enterprise;
  if (!isEnterprise) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "mb-10 flex flex-col justify-center gap-x-6 lg:mx-4 lg:flex-row"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "flex flex-col lg:w-[966px]"
    }, /*#__PURE__*/React__default.createElement(Article, {
      data: article.data,
      messages: article.messages,
      upsellMessage: article.upsellMessage
    }), youMayAlsoLike && /*#__PURE__*/React__default.createElement("div", {
      className: "hidden lg:flex"
    }, /*#__PURE__*/React__default.createElement(YouMayAlsoLike, {
      messages: youMayAlsoLike.messages,
      articles: youMayAlsoLike.articles,
      articleClickHandler: youMayAlsoLike.articleClickHandler
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "flex flex-col gap-y-10 lg:w-[300px]"
    }, responsiveAds && /*#__PURE__*/React__default.createElement("div", {
      className: "text-center"
    }, " ", responsiveAds, " "), /*#__PURE__*/React__default.createElement("div", {
      className: "flex flex-col gap-y-6 lg:w-[300px]"
    }, miniArticleList && /*#__PURE__*/React__default.createElement("div", {
      className: "order-2 lg:order-1"
    }, /*#__PURE__*/React__default.createElement(MiniArticleList, miniArticleList)), articleRelationsList && /*#__PURE__*/React__default.createElement("div", {
      className: "order-1 lg:order-2"
    }, /*#__PURE__*/React__default.createElement(ArticleRelationsList, {
      relations: articleRelationsList.relations,
      sectionHeading: articleRelationsList.sectionHeading
    })))));
  } else {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "flex flex-row"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "h-screen w-full"
    }, /*#__PURE__*/React__default.createElement(ArticleBody, {
      body: article.data.body,
      showFullArticle: article.data.showFullArticle,
      templateType: article.data.templateType,
      promoLabel: ''
    })));
  }
};

export { ArticlePage };
//# sourceMappingURL=article-page.esm.js.map
